module.exports = __webpack_public_path__ + "img/m7.8bd1ea0a.jpg";